<template>
  <div id="product" class="c-content">
    <!-- <banner-child :content="banner"></banner-child>

    <product-content v-for="(item, index) in productItem" :key="index" :content="item"></product-content>

    <div class="c-standard" style="padding-top: 0">
      <product-page-route :index="index"></product-page-route>
    </div> -->
  </div>
</template>

<script>
  import BannerChild from '../layout/bannerChild.vue'
  import ProductPageRoute from '../layout/productPageRoute.vue'
  import ProductContent from '../layout/productContent.vue'

  export default {
    name: 'product_1',
    components: {
      'banner-child': BannerChild,
      'product-page-route': ProductPageRoute,
      'product-content' : ProductContent
    },
    data(){
      return {
        text: {
          more: this.$t('common.more')
        },
        banner: {
          img: require('../../assets/img/product/product_banner_01.jpg'),
          title: this.$t('product_1.banner.title'),
          content: this.$t('product_1.banner.content'),
        },
        index: 0,
        productItem:[
          {
            title: this.$t('product_1.content.item1.title'),
            bgColor: "#ffffff",
            left: [
              {
                title: "",
                content: [
                  {type: "text", content: this.$t('product_1.content.item1.block1.text1')},
                  {type: "text", content: this.$t('product_1.content.item1.block1.text2')},
                  {type: "img", img: require('../../assets/img/product/wibo-01.jpg')}
                ]
              },
              {
                title: this.$t('product_1.content.item1.block2.title'),
                content: [
                  {type: "text", content: this.$t('product_1.content.item1.block2.text1')},
                  {type: "img", img: require('../../assets/img/product/wibo-02.jpg')}
                ]
              }
            ],
            right: [
              {
                title: this.$t('product_1.content.item1.block3.title'),
                content: [
                  {type: "text", content: this.$t('product_1.content.item1.block3.text1')},
                  {type: "list", content: [this.$t('product_1.content.item1.block3.list1'),this.$t('product_1.content.item1.block3.list2'),this.$t('product_1.content.item1.block3.list3'),this.$t('product_1.content.item1.block3.list4'),this.$t('product_1.content.item1.block3.list5'),this.$t('product_1.content.item1.block3.list6')]},
                  {type: "img", img: require('../../assets/img/product/wibo-03.jpg')}
                ]
              }
            ],
            midd: [
              {
                title: this.$t('product_1.content.item1.block4.title'),
                content: [
                  {type: "text", content: this.$t('product_1.content.item1.block4.text1')},
                  {type: "block", content: [
                    {img: require('../../assets/img/product/wibo-04.jpg'), title: this.$t('product_1.content.item1.block4.blocks.block1.title'), content: this.$t('product_1.content.item1.block4.blocks.block1.content')},
                    {img: require('../../assets/img/product/wibo-06.jpg'), title: this.$t('product_1.content.item1.block4.blocks.block2.title'), content: this.$t('product_1.content.item1.block4.blocks.block2.content')},
                    {img: require('../../assets/img/product/wibo-05.jpg'), title: this.$t('product_1.content.item1.block4.blocks.block3.title'), content: this.$t('product_1.content.item1.block4.blocks.block3.content')},
                  ]}
                ]
              }
            ]
          },
          {
            title: this.$t('product_1.content.item4.title'),
            bgColor: "#ecedee",
            left: [
              {
                title: "",
                content: [
                  {type: "text", content: this.$t('product_1.content.item4.block1.text1')}
                ]
              },
              {
                title: this.$t('product_1.content.item4.block2.title'),
                content: [
                  {type: "text", content: this.$t('product_1.content.item4.block2.text1')},
                  {type: "text", content: this.$t('product_1.content.item4.block2.text2')}
                ]
              },
              {
                title: this.$t('product_1.content.item4.block3.title'),
                content: [
                  {type: "text", content: this.$t('product_1.content.item4.block3.text1')},
                  {type: "text", content: this.$t('product_1.content.item4.block3.text2')},
                  {type: "text", content: this.$t('product_1.content.item4.block3.text3')}
                ]
              }
            ],
            right: [
              {
                title: this.$t('product_1.content.item4.block4.title'),
                content: [
                  {type: "text", content: this.$t('product_1.content.item4.block4.text1')},
                  {type: "text", content: this.$t('product_1.content.item4.block4.text2')},
                  {type: "img", img: require('../../assets/img/product/wibo-07.jpg')},
                  {type: "img", img: require('../../assets/img/product/wibo-08.jpg')}
                ]
              }
            ]
          },
          {
            title: this.$t('product_1.content.item5.title'),
            bgColor: "#ffffff",
            left: [
              {
                title: "",
                content: [
                  {type: "text", content: this.$t('product_1.content.item5.block1.text1')}
                ]
              },
              {
                title: this.$t('product_1.content.item5.block2.title'),
                content: [
                  {type: "text", content: this.$t('product_1.content.item5.block2.text1')},
                ]
              },
              {
                title: this.$t('product_1.content.item5.block3.title'),
                content: [
                  {type: "text", content: this.$t('product_1.content.item5.block3.text1')},
                ]
              },
              {
                title: this.$t('product_1.content.item5.block4.title'),
                content: [
                  {type: "text", content: this.$t('product_1.content.item5.block4.text1')}
                ]
              }
            ],
            right: [
              {
                title: "",
                content: [
                  {type: "img", img: require('../../assets/img/product/wibo-09.jpg')}
                ]
              }
            ]
          },
          {
            title: this.$t('product_1.content.item2.title'),
            bgColor: "#ecedee",
            left: [
              {
                title: "",
                content: [
                  {type: "text", content: this.$t('product_1.content.item2.block1.text1')}
                ]
              },
              {
                title: this.$t('product_1.content.item2.block2.title'),
                content: [
                  {type: "text", content: this.$t('product_1.content.item2.block2.text1')}
                ]
              },
              {
                title: this.$t('product_1.content.item2.block3.title'),
                content: [
                  {type: "text", content: this.$t('product_1.content.item2.block3.text1')},
                  {type: "text", content: this.$t('product_1.content.item2.block3.text2')},
                  {type: "text", content: this.$t('product_1.content.item2.block3.text3')},
                  {type: "text", content: this.$t('product_1.content.item2.block3.text4')}
                ]
              }
            ],
            right: [
              {
                title: this.$t('product_1.content.item2.block4.title'),
                content: [
                  {type: "text", content: this.$t('product_1.content.item2.block4.text1')},
                  {type: "img", img: require('../../assets/img/product/wibo-10.jpg')}
                ]
              }
            ]
          },
          {
            title: this.$t('product_1.content.item3.title'),
            bgColor: "#ffffff",
            left: [
              {
                title: "",
                content: [
                  {type: "text", content: this.$t('product_1.content.item3.block1.text1')}
                ]
              },
              {
                title: this.$t('product_1.content.item3.block2.title'),
                content: [
                  {type: "list", content: [this.$t('product_1.content.item3.block2.list1'),this.$t('product_1.content.item3.block2.list2'),this.$t('product_1.content.item3.block2.list3'),this.$t('product_1.content.item3.block2.list4'),this.$t('product_1.content.item3.block2.list5'),this.$t('product_1.content.item3.block2.list6'),this.$t('product_1.content.item3.block2.list7')]},
                ]
              },
              {
                title: this.$t('product_1.content.item3.block3.title'),
                content: [
                  {type: "list", content: [this.$t('product_1.content.item3.block3.list1'),this.$t('product_1.content.item3.block3.list2'),this.$t('product_1.content.item3.block3.list3'),this.$t('product_1.content.item3.block3.list4'),this.$t('product_1.content.item3.block3.list5'),this.$t('product_1.content.item3.block3.list6'),this.$t('product_1.content.item3.block3.list7'),this.$t('product_1.content.item3.block3.list8')]},
                ]
              },
              {
                title: this.$t('product_1.content.item3.block4.title'),
                content: [
                  {type: "text", content: this.$t('product_1.content.item3.block4.text1')},
                  {type: "text", content: this.$t('product_1.content.item3.block4.text2')},
                ]
              },
              {
                title: this.$t('product_1.content.item3.block5.title'),
                content: [
                  {type: "text", content: this.$t('product_1.content.item3.block5.text1')},
                  {type: "img", img: require('../../assets/img/product/wibo-13.jpg')}
                ]
              }
            ],
            right: [
              {
                title: "",
                content: [
                  {type: "img", img: require('../../assets/img/product/wibo-11.jpg')},
                  {type: "img", img: require('../../assets/img/product/wibo-12.jpg')},
                ]
              }
            ]
          },
        ]
      }
    },
    computed: {

    },
    created () {

    },
    methods: {

    },
  }
</script>

<style>

</style>
